import AlertsAll from 'common/alerts/containers/alert-all-container';
import DashboardContainer from 'common/dashboard/containers/dashboard-container';
import CreateOrders from 'order/create/containers/create-orders-container';
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { referenceTypes } from '../../utils/app-configs';

const EquipmentDashboard = ({ id, renderMenu, renderConnectionStatus }) =>
  <>
    <DashboardContainer
      type={referenceTypes.equipment}
      id={id}
      hasContract={true}
      hasShortTimeline={true}
      renderMenu={renderMenu}
      renderConnectionStatus={renderConnectionStatus}
      canCreateOrder={true}
      canCreateTicket={true}
    />
    <Routes>
      <Route path={'alerts'} element={<AlertsAll />} />
      <Route path={'create-order/:type/:ids'} element={<CreateOrders />} />
    </Routes>
  </>;

EquipmentDashboard.propTypes = {
  id: PropTypes.string,
  renderMenu: PropTypes.func.isRequired,
  renderConnectionStatus: PropTypes.func,
};

export default EquipmentDashboard;
